<div class="sh-form-multiselect" style="width: 100%" (shClickOutside)="closeDropdown()">
    <sh-droppanel-select
        [isOpen$]="openDropdown$"
        [multiple]="false"
        [allowSingleDeselect]="true"
        [initialSelectedValues]="initialSelectedValues$ | async"
        [options]="thesaurusOptions$ | async"
        [search]="true"
        [searchPlaceholderMsg]="'ui.search' | translate"
        [loading$]="lookupLoading$"
        [loadingMsg]="'ui.search-loading' | translate"
        [itemCapCount]="itemCapCount"
        [listCappedMsg]="'ui.capped-results' | translate"
        [noResultsActionItem]="noResultsActionItem$ | async"
        [noResultsFoundMsg]="'ui.no-results' | translate"
        [limitHeightToViewport]="false"
        [valueToLabelFct]="thesaurusConceptToLabel"
        (selectionState)="onSelectionStateChange($event)"
        (searchTerm)="onSearchTermChange($event)"
    >
        <button
            type="button"
            class="sh-icon-button sh-form-group__input sh-form-multiselect__select"
            (click)="toggleDropdown()"
            [attr.disabled]="(disabled$ | async) ? true : null"
            [title]="title$ | async"
            [shAutoFocus]="autoFocus"
        >
            <span class="sh-form-multiselect__select__label">{{ selectLabel$ | async }}</span>
            <svg sh-icon class="sh-icon-button__icon--end push-right" [name]="'angle-down'" [size]="'small'" aria-hidden="true"></svg>
        </button>
    </sh-droppanel-select>
</div>
